// we're in a deeper folder than fields.js - assume it is loaded
PD.forms.fields.PhoneField = (function(){
  function PhoneField(cfg, index, form) {
    this._super.apply(this, arguments); // call generic TextField constructor
  }
  PhoneField.prototype = {
    _template: 
      '<% if (!bare) { %><div class="form-group">' +
        '<label for="<%=id%>" class="col-sm-3 control-label"><%=label?label+\':\':\'\'%></label>' +
        '<div class="col-sm-<%=helpText? "8" : "9"%>">' +
          '<% } %><div class="input-group">' +
            '<span class="input-group-btn">' +
              '<select id="<%=id%>_1" style="width:auto;" class="form-control">' +
                '<% for (var i = 0; i < countryCodes.length; i++) { %>' +
                '<option><%=countryCodes[i]%></option>' +
                '<% } %>' +
              '</select>' +
            '</span>' +
            '<input type="text" class="form-control" id="<%=id%>_2" name="<%=name%>" placeholder="<%=placeholder===false? \'\' : placeholder || label%>">' +
          '</div> <% if (!bare) { %>' +
        '</div>' +
      '<% if (helpText) { %>' +
        '<div class="col-sm-1 hidden-xs">' +
          '<i class="fa fa-question-circle-o" role="button" data-toggle="popover" title="<%=helpText.title%>" data-content="<%=helpText.content%>"></i>'+
        '</div>' +
      '<% } %>' +

      '<% if (errorText) { %>' +
        '<div class="col-sm-9 col-sm-offset-3 error-text">' +
          '<p id="<%=id%>_error"><%=errorText["+45"]%></p>' +
        '</div>' +
      '<% } %>' +
      '<% if (inlineHelpText || errorText) { %>' +
        '<div class="col-sm-9 col-sm-offset-3 help-block">' +
          '<p><%=inlineHelpText%></p>' +
        '</div>' +
      '<% } %>' +

      '</div><% } %>',
    
    bare: false,

    countryCodes: ["+45", "+49"],

    regex: {
      "+354": /^\d(?:[ -]?\d){6}(?:[ -]?\d{2})?$/,// Iceland
      "+353": /^(\d[ \-]?){6,10}$/,               // Ireland
      "+41": /^(\d[ \-]?){9}$/,                   // Switzerland
      "+43": /^([\- \(\)]?\d[\- \(\)]?){3,14}$/,  // Austria
      "+44": /^([\- \(\)]?\d[\- \(\)]?){3,11}$/,  // United Kingdom
      "+45": /^(\d[ \-]?){8}$/,                   // Denmark
      "+49": /^([\- \(\)]?\d[\- \(\)]?){3,14}$/,  // Germany
    },
    errorText: null,
  };

  // generic _super overwrite
  PhoneField.prototype._get$Element = function(){
    this._super.prototype._get$Element.apply(this, arguments);

    // bind specific listeners to our element
    this.$inp1 = $("#"+this.id+"_1", this.$elm);
    this.$inp2 = $("#"+this.id+"_2", this.$elm);
    this.$inp1.add(this.$inp2) // both inputs
      .on("input", this.validate.bind(this) );

    return this.$elm;
  };

  // see TextField in fields.js for explanation
  PhoneField.prototype._setFeedback = function(feedback) {
    if (this._feedback !== feedback) {
      // remove existing feedback
      this.$elm.find(".form-control-feedback").remove();
      this.$elm.removeClass("has-warning has-error has-feedback");

      // add new feedback
      if (feedback) {
        var type = feedback === "error" ? "error" : "warning";
        var icon = feedback === "mandatory" ? "asterisk" : "warning";
        this.$elm.addClass("has-feedback has-"+type);
        this.$inp2.after("<i class='fa fa-"+icon+" form-control-feedback'></i>");
      }
      this._feedback = feedback;
    }
  };

  // see TextField in fields.js for explanation
  PhoneField.prototype.validate = function() {
    var valid, feedback;
    var phone_code = this.$inp1.val();
    var phone = this.$inp2.val();

    var error = this.errorText || {
      "+354": PD.homepage.__h("Please enter your phone number (7 or 9 digits)"),
      "+353": PD.homepage.__h("Please enter your phone number (6-10 digits)"),
      "+41": PD.homepage.__h("Please enter your phone number (9 digits)"),
      "+43": PD.homepage.__h("Please enter your phone number (3-14 digits)"),
      "+44": PD.homepage.__h("Please enter your phone number (3-11 digits)"),
      "+45": PD.homepage.__h("Please enter your phone number (8 digits)"),
      "+49": PD.homepage.__h("Please enter your phone number (3-14 digits)")
    };

    // TODO: why do we allow either to be empty?
    valid = true;
    valid = (phone === "" || this.regex[phone_code].test(phone));
    if (valid === false) {
      feedback = "error";
      this.$elm.find("#" + this.id + "_error").text(error[phone_code]);
    }
    
    this._setFeedback(feedback);
    
    return valid;
  };

  PhoneField.prototype.getValue = function() {
    return [this.$inp1.val(),this.$inp2.val()];
  };

  PhoneField.prototype.setValue = function(value) {
    var ret = false;
    if ($.isArray(value) && value.length === 2) {
      this.$inp1.val(value[0]);
      this.$inp2.val(value[1]);
      ret = true;
    }

    return ret;
  };

  // inherit from generic field
  PD.forms.fields.register(["phone", "PhoneField"], PhoneField);

  return PhoneField;
})();
